export default __webpack_public_path__ + "static/media/arrowLeft.7e026811.svg";